var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58332 18.1243C4.87499 18.1243 1.04166 14.291 1.04166 9.58268C1.04166 4.87435 4.87499 1.04102 9.58332 1.04102C14.2917 1.04102 18.125 4.87435 18.125 9.58268C18.125 14.291 14.2917 18.1243 9.58332 18.1243ZM9.58332 2.29102C5.55832 2.29102 2.29166 5.56602 2.29166 9.58268C2.29166 13.5993 5.55832 16.8743 9.58332 16.8743C13.6083 16.8743 16.875 13.5993 16.875 9.58268C16.875 5.56602 13.6083 2.29102 9.58332 2.29102Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 18.9576C18.175 18.9576 18.0167 18.8992 17.8917 18.7742L16.225 17.1076C15.9833 16.8659 15.9833 16.4659 16.225 16.2242C16.4667 15.9826 16.8667 15.9826 17.1083 16.2242L18.775 17.8909C19.0167 18.1326 19.0167 18.5326 18.775 18.7742C18.65 18.8992 18.4917 18.9576 18.3333 18.9576Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.103974dffedeeca6f500e042eca03eed.svg";
export { ForwardRef as ReactComponent };